import React, { memo, useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { ModalSecondAccess } from './ModalSecondAccess';
import { IModalSecondAccess } from './interfaces';

export const Container: React.FC<IModalSecondAccess> = ({
  open,
  onClose,
  nameStore,
}) => {
  const isSharingLocation = useMemo(() => {
    const isSharing = localStorage.getItem('@Popeyes.isSharing');
    const isSharingStorage: boolean = JSON.parse(isSharing);

    return !!isSharingStorage;
  }, []);

  return (
    <ModalSecondAccess
      open={open}
      onClose={onClose}
      nameStore={nameStore}
      isSharingLocation={isSharingLocation}
    />
  );
};
